"use client";

import { Button } from "@chakra-ui/react";
import Image from "next/image";

type KoFiButtonProps = {
  onClick?: () => void;
};

export function KoFiButton({ onClick }: KoFiButtonProps) {
  function handleClick() {
    window.open("https://ko-fi.com/U7U21TWQBW", "_blank", "noopener,noreferrer");
    onClick?.();
  }

  return (
    <Button
      type="button"
      aria-label="Support BongGo on Ko-fi"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      h="30px"
      minW="auto"
      p={0}
      bg="transparent"
      lineHeight={0}
      onClick={handleClick}
      _hover={{ transform: "translateY(-1px)" }}
    >
      <Image
        src="/kofi5.png"
        alt="Buy Me a Coffee at ko-fi.com"
        width={580}
        height={146}
        style={{ height: "30px", width: "auto", border: 0, display: "block" }}
      />
    </Button>
  );
}
